<template>
  <div
    class="modal fade"
    id="editKpiDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form id="editKpiDialogForm">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
            <h4 class="modal-title">
              <b>{{ lang.KM2000 }}</b>
            </h4>
            <p>
              <b>{{ lang.KM2026 }}:</b>
              {{ nameOfSelectedClient }}
              <b>/ {{ lang.KM2029 }}:</b>
              {{ nameOfSelectedProject }}
              <b>/ {{ lang.KM2027 }}:</b>
              {{ nameOfSelectedKpiGroup }}
              <b>/ {{ lang.KM2028 }}:</b>
              {{ nameOfSelectedEvaluationRuleGuid }}
            </p>
          </div>
          <div class="modal-body">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="col-md-6" style="padding-left: 0">
                  <div
                    class="form-group searchbar col-md-4"
                    style="padding-left: 15px; top: 9px"
                  >
                    <select2
                      class="form-control"
                      v-model="selectedClient"
                      @change="
                        getClientProjectList(), getKpiGroupsOfSelectedClient()
                      "
                      :disabled="
                        feature.isAudiTarget &&
                        feature.isEnabled('audi_importers')
                      "
                    >
                      <option
                        v-for="client in clientList"
                        :key="client.ClientGuid"
                        :value="client.ClientGuid"
                      >
                        {{ client.ClientName }}
                      </option>
                    </select2>
                  </div>
                  <div
                    class="form-group searchbar col-md-4"
                    style="padding-left: 15px; top: 9px"
                  >
                    <select2
                      class="form-control"
                      v-model="selectedProjectGuid"
                      :disabled="clientProjectList.length < 1"
                      :placeholder="lang.KM2030"
                      :allowClear="true"
                      @change="filterKpiGroupsByProject()"
                    >
                      <option></option>
                      <option
                        v-for="project in clientProjectList"
                        :key="project.ProjectGuid"
                        :value="project.ProjectGuid"
                      >
                        {{ project.ProjectName }}
                      </option>
                    </select2>
                  </div>
                  <div
                    class="form-group searchbar col-md-4"
                    style="padding-left: 15px; top: 9px"
                  >
                    <select2
                      class="form-control"
                      :placeholder="lang.KM2001"
                      :allowClear="true"
                      :disabled="
                        !selectedProjectGuid || projectKpiGroupList.length < 1
                      "
                      v-model="selectedKpiGroupGuid"
                      @change="createNewKpi(), getKpisOfSelectedKpiGroup()"
                    >
                      <option></option>
                      <option
                        v-for="kpiGroup in projectKpiGroupList"
                        :key="kpiGroup.KPIGroupGuid"
                        :value="kpiGroup.KPIGroupGuid"
                      >
                        {{ kpiGroup.KPIGroupCode }}
                      </option>
                    </select2>
                  </div>
                  <div class="table-container" style="clear: both">
                    <table class="table table-striped table-hover">
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 20%">
                            {{ lang.KM2002 }}
                          </th>
                          <th class="text-center" style="width: 25%">
                            {{ lang.KM2003 }}
                          </th>
                          <th class="text-center" style="width: 55%">
                            {{ lang.KM2004 }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          role="button"
                          :key="kpi.KPIGuid"
                          :class="{ info: selectedKpiGuid === kpi.KPIGuid }"
                          @click="(selectedKpiGuid = kpi.KPIGuid), getKpiData()"
                          v-for="kpi in kpisOfSelectedKpiGroup"
                        >
                          <td style="width: 20%">
                            {{ kpi.KPIGroupPosition }}
                          </td>
                          <td style="width: 25%">{{ kpi.KPICode }}</td>
                          <td style="width: 55%">{{ kpi.KPIShortText }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-6" style="padding-right: 0">
                  <ul
                    class="nav nav-tabs nav-kpi-edit"
                    style="margin-bottom: 5px"
                  >
                    <li class="active">
                      <a
                        href="#editKpiTab"
                        data-toggle="tab"
                        @click="selectedTab = 'editKpiTab'"
                        >{{ lang.KM2005 }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="#kpiOrderInKpiGroupTab"
                        data-toggle="tab"
                        @click="selectedTab = 'kpiOrderInKpiGroupTab'"
                        >{{ lang.KM2006 }}</a
                      >
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane fade active in" id="editKpiTab">
                      <form class="form-horizontal">
                        <div class="form-group">
                          <label
                            for="inputKpiCode"
                            id="inputKpiCodeLabel"
                            class="col-md-3 control-label"
                          >
                            {{ lang.KM2007 }} *
                            <i class="material-icons md-18">help_outline</i>
                          </label>
                          <div class="col-md-9">
                            <input
                              type="text"
                              class="form-control"
                              maxlength="200"
                              id="inputKpiCode"
                              :disabled="
                                !selectedProjectGuid === '' ||
                                selectedKpiGroupGuid === ''
                              "
                              @input="selectedKpiDirty = true"
                              v-model="selectedKpiInformation.KPICode"
                              required
                            />
                            <span
                              v-show="inputHasError('inputKpiCode')"
                              class="help-block error text-danger"
                              >{{ lang.KM2011 }}</span
                            >
                          </div>
                          <b-tooltip
                            ref="tooltip"
                            target="inputKpiCodeLabel"
                            placement="right"
                            :delay="globals.tooltipDelay"
                            >{{ lang.KM2037 }}</b-tooltip
                          >
                        </div>
                        <div class="form-group">
                          <label
                            for="inputKpiShortText"
                            id="inputKpiShortTextLabel"
                            class="col-md-3 control-label"
                          >
                            {{ lang.KM2008 }} *
                            <i class="material-icons md-18">help_outline</i>
                          </label>
                          <div class="col-md-9">
                            <input
                              type="text"
                              class="form-control"
                              maxlength="50"
                              id="inputKpiShortText"
                              :disabled="
                                !selectedProjectGuid === '' ||
                                selectedKpiGroupGuid === ''
                              "
                              @input="selectedKpiDirty = true"
                              v-model="selectedKpiInformation.KPIShortText"
                              required
                            />
                            <span
                              v-show="inputHasError('inputKpiShortText')"
                              class="help-block error text-danger"
                              >{{ lang.KM2011 }}</span
                            >
                          </div>
                          <b-tooltip
                            ref="tooltip"
                            target="inputKpiShortTextLabel"
                            placement="right"
                            :delay="globals.tooltipDelay"
                            >{{ lang.KM2034 }}</b-tooltip
                          >
                        </div>
                        <div class="form-group">
                          <label
                            for="inputKpiLongText"
                            id="inputKpiLongTextLabel"
                            class="col-md-3 control-label"
                          >
                            {{ lang.KM2009 }} *
                            <i class="material-icons md-18">help_outline</i>
                          </label>
                          <div class="col-md-9">
                            <input
                              type="text"
                              class="form-control"
                              maxlength="200"
                              id="inputKpiLongText"
                              :disabled="
                                !selectedProjectGuid === '' ||
                                selectedKpiGroupGuid === ''
                              "
                              @input="selectedKpiDirty = true"
                              v-model="selectedKpiInformation.KPILongText"
                              required
                            />
                            <span
                              v-show="inputHasError('inputKpiLongText')"
                              class="help-block error text-danger"
                              >{{ lang.KM2011 }}</span
                            >
                          </div>
                          <b-tooltip
                            ref="tooltip"
                            target="inputKpiLongTextLabel"
                            placement="right"
                            :delay="globals.tooltipDelay"
                            >{{ lang.KM2035 }}</b-tooltip
                          >
                        </div>
                        <div class="form-group">
                          <label
                            for="inputKpiWeight"
                            id="inputKpiWeightLabel"
                            class="col-md-3 control-label"
                          >
                            {{ lang.KM2032 }}
                            <i class="material-icons md-18">help_outline</i>
                          </label>
                          <div class="col-md-9">
                            <input
                              type="number"
                              class="form-control"
                              id="inputKpiWeight"
                              min="0"
                              max="100"
                              step="0.01"
                              :disabled="
                                !selectedProjectGuid === '' ||
                                selectedKpiGroupGuid === ''
                              "
                              @input="selectedKpiDirty = true"
                              v-model.number="selectedKpiInformation.KPIWeight"
                            />
                          </div>
                          <b-tooltip
                            ref="tooltip"
                            target="inputKpiWeightLabel"
                            placement="right"
                            :delay="globals.tooltipDelay"
                            >{{ lang.KM2036 }}</b-tooltip
                          >
                        </div>
                        <div class="form-group">
                          <label
                            for="KPIManagementSelectEvaluation"
                            class="col-md-3 control-label"
                            >{{ lang.KM2028 }}</label
                          >
                          <div class="col-md-9">
                            <select2
                              class="form-control"
                              id="KPIManagementSelectEvaluation"
                              v-model="
                                selectedKpiInformation.KPIEvaluationRuleGuid
                              "
                              :placeholder="lang.KM2031"
                              :allowClear="true"
                              :disabled="
                                !selectedProjectGuid === '' ||
                                selectedKpiGroupGuid === ''
                              "
                              @change="selectedKpiDirty = true"
                            >
                              <option></option>
                              <option
                                v-for="evaluation in kpiEvaluationRulesList"
                                :key="evaluation.EvaluationRuleGuid"
                                :value="evaluation.EvaluationRuleGuid"
                              >
                                {{ evaluation.EvaluationRule }}
                              </option>
                            </select2>
                          </div>
                        </div>
                        <div class="form-group">
                          <label
                            for="inputKpiDescription"
                            class="col-md-3 control-label"
                            >{{ lang.KM2010 }}</label
                          >
                          <div class="col-md-9">
                            <textarea
                              rows="3"
                              type="text"
                              class="form-control"
                              maxlength="500"
                              id="inputKpiDescription"
                              :disabled="
                                !selectedProjectGuid === '' ||
                                selectedKpiGroupGuid === ''
                              "
                              @input="selectedKpiDirty = true"
                              v-model="selectedKpiInformation.KPIDescription"
                            ></textarea>
                          </div>
                        </div>
                      </form>
                      <div style="margin: 25px 0 25px 0">
                        <b-alert
                          variant="danger"
                          dismissible
                          :show="showAlert"
                          @dismissed="showAlert = false"
                          >{{ lang.KM2012 }}</b-alert
                        >
                      </div>
                      <div>
                        <button
                          type="button"
                          class="btn btn-raised btn-top-bar"
                          :disabled="!selectedKpiGuid && !selectedKpiDirty"
                          @click="createNewKpi()"
                        >
                          <i class="material-icons md-36">add_box</i>
                          <br />
                          {{ lang.KM2013 }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-raised btn-top-bar"
                          :class="{ 'btn-warning': selectedKpiDirty }"
                          :disabled="!selectedKpiGuid && !selectedKpiDirty"
                          @click="validateBeforeSubmit('editKpiDialog')"
                        >
                          <i class="material-icons md-36">save</i>
                          <br />
                          {{ lang.KM2014 }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-raised btn-top-bar"
                          :disabled="!selectedKpiGuid"
                          @click="openDeleteKpiConfirmationDialog()"
                        >
                          <i class="material-icons md-36">delete</i>
                          <br />
                          {{ lang.KM2015 }}
                        </button>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="kpiOrderInKpiGroupTab">
                      <div class="table-container table-positions">
                        <table class="table table-striped table-hover">
                          <thead>
                            <tr>
                              <th style="width: 80%" class="text-center">
                                {{ lang.KM2016 }}
                              </th>
                              <th style="width: 20%">{{ lang.KM2017 }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="kpi in kpisOfSelectedKpiGroup"
                              :key="kpi.KPIGroupPosition"
                            >
                              <td style="width: 80%">
                                {{ kpi.KPIShortText }}
                              </td>
                              <td class="nopadding">
                                <div
                                  class="form-group nopadding"
                                  style="width: 60%; float: left"
                                >
                                  <select
                                    class="form-control text-center nopadding"
                                    v-model="kpi.KPIGroupPosition"
                                    @change="
                                      reorderKpisInKpiGroup(kpi.KPICode),
                                        (changeKpiOrderDirty = true)
                                    "
                                  >
                                    <option
                                      v-for="kpi2 in kpisOfSelectedKpiGroup"
                                      :key="kpi2.KPIGroupPosition"
                                      :value="kpi2.KPIGroupPosition"
                                    >
                                      {{ kpi2.KPIGroupPosition }}
                                    </option>
                                  </select>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <button
                        type="button"
                        class="btn btn-raised btn-default"
                        :class="{ 'btn-warning': changeKpiOrderDirty }"
                        :disabled="kpisOfSelectedKpiGroup.length < 1"
                        @click="saveKpisNewOrder()"
                      >
                        {{ lang.KM2033 }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.KM2018 }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

export default {
  name: "KPIManagementEditModal",
  components: {
    Select2,
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#editKpiDialog").on("hide.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });

    this.globals.$off("KPIDeleteModalYesConfirmation");
    this.globals.$on("KPIDeleteModalYesConfirmation", () => {
      this.deleteSelectedKpi();
    });
  },
  props: [
    "showDialog",
    "clientList",
    "selectedClientForKpi",
    "projectList",
    "kpiEvaluationRulesList",
  ],
  watch: {
    showDialog() {
      this.showDialog ? this.openEditKpiDialog() : this.closeEditKpiDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  data() {
    return {
      selectedClient: "",
      kpiGroupsOfSelectedClient: [],
      selectedTab: "editKpiTab",
      selectedKpiGroupGuid: "",
      kpisOfSelectedKpiGroup: [],
      selectedKpiDirty: false,
      selectedKpiGuid: "",
      invalidInputIds: [],
      showAlert: false,
      changeKpiOrderDirty: false,
      selectedKpiGroupInformation: {},
      clientProjectList: [],
      selectedProjectGuid: "",
      projectKpiGroupList: [],
      selectedKpiInformation: {
        KPICode: "",
        KPIShortText: "",
        KPILongText: "",
        KPIDescription: "",
        KPIGroups: [],
      },
      lang: {
        KM2000: "KPI Management",
        KM2001: "Select a KPI Group…",
        KM2002: "Position",
        KM2003: "KPI Code",
        KM2004: "KPI Shorttext",
        KM2005: "Edit KPI",
        KM2006: "KPI Order",
        KM2007: "KPI Code",
        KM2008: "KPI Shorttext",
        KM2009: "KPI Longtext",
        KM2010: "Description",
        KM2011: "This is a required entry!",
        KM2012:
          "Your inputs are incorrect. Please check the fields marked in red!",
        KM2013: "New",
        KM2014: "Save",
        KM2015: "Delete",
        KM2016: "KPI Shorttext",
        KM2017: "Position",
        KM2018: "Close",
        KM2019: "Delete KPI",
        KM2020: "Yes",
        KM2021: "No",
        KM2022: "Do you really want to delete the following KPI?",
        KM2023: "ID",
        KM2024: "KPI Code",
        KM2025: "KPI Shorttext",
        KM2026: "Client",
        KM2027: "KPI Group",
        KM2028: "Evaluation rule",
        KM2029: "Project",
        KM2030: "Please select a project...",
        KM2031: "Inherited",
        KM2032: "Weight",
        KM2033: "Save positions",
        KM2034:
          "KPI Shorttext – max. 50 characters, will be visible in Cockpit",
        KM2035: "KPI Longtext – max. 200 characters",
        KM2036: "Weight of the KPI within the KPI Group",
        KM2037: "KPI Code – max. 200 characters",
      },
    };
  },
  computed: {
    nameOfSelectedClient() {
      if (this.selectedClient === "") return " - ";
      let client = this.clientList.find(
        (c) => c.ClientGuid === this.selectedClient
      );
      return client ? client.ClientName : " - ";
    },
    nameOfSelectedKpiGroup() {
      if (this.selectedKpiGroupGuid === "") return " - ";
      let kpiGroup = this.kpiGroupsOfSelectedClient.find(
        (element) => element.KPIGroupGuid === this.selectedKpiGroupGuid
      );
      return kpiGroup ? kpiGroup.KPIGroupShortText : " - ";
    },
    nameOfSelectedEvaluationRuleGuid() {
      if (this.selectedKpiGroupGuid === "") return " - ";
      let kpiGroup = this.kpiGroupsOfSelectedClient.find(
        (element) => element.KPIGroupGuid === this.selectedKpiGroupGuid
      );
      let evaluationRule = this.kpiEvaluationRulesList.find(
        (element) =>
          element.EvaluationRuleGuid === kpiGroup.KPIEvaluationRuleGuid
      );
      return evaluationRule ? evaluationRule.EvaluationRule : " - ";
    },
    nameOfSelectedProject() {
      if (this.selectedProjectGuid === "") return " - ";
      let projectName = this.clientProjectList.filter(
        (project) => project.ProjectGuid === this.selectedProjectGuid
      );
      return projectName ? projectName[0].ProjectName : " - ";
    },
  },
  methods: {
    initEditKpiDialog() {
      this.createNewKpi();
      this.selectedClient = this.selectedClientForKpi;
      this.getKpiGroupsOfSelectedClient();
      this.selectedKpiGuid = "";
      this.selectedKpiGroupGuid = "";
      this.changeKpiOrderDirty = false;
      this.kpiGroupsOfSelectedClient = [];
      this.kpisOfSelectedKpiGroup = [];
      this.selectedKpiGroupInformation = {};
    },
    createNewKpi() {
      this.selectedKpiInformation = {
        KPICode: "",
        KPIShortText: "",
        KPILongText: "",
        KPIDescription: "",
        KPIGroups: [],
      };
      this.selectedKpiGuid = "";
      this.showAlert = false;
      this.selectedKpiDirty = false;
      this.resetValidationErrors("editKpiDialog");
    },
    openEditKpiDialog() {
      $("#editKpiDialog").modal("show");
      this.initEditKpiDialog();
      this.getClientProjectList();
    },
    closeEditKpiDialog() {
      $("#editKpiDialog").modal("hide");
    },
    getClientProjectList() {
      this.selectedProjectGuid = "";
      this.selectedKpiGroupGuid = "";
      this.clientProjectList = [];
      this.kpisOfSelectedKpiGroup = [];

      if (this.selectedClient) {
        let listOfClientProjects = this.projectList.filter(
          (project) => project.ClientGuid === this.selectedClient
        );
        if (listOfClientProjects.length > 0) {
          this.clientProjectList = listOfClientProjects[0].Projects;
          this.sortClientProjectList();
        }
      }
    },
    sortClientProjectList() {
      this.clientProjectList.sort((a, b) => {
        if (a.ProjectName.toLowerCase() < b.ProjectName.toLowerCase())
          return -1;
        if (a.ProjectName.toLowerCase() > b.ProjectName.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpiGroupsOfSelectedClient() {
      if (!this.selectedClient) return;
      this.selectedKpiGroupGuid = "";
      this.kpisOfSelectedKpiGroup = [];
      this.createNewKpi();

      let queryString = `api/KPIGroups/Client/${this.selectedClient}`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.kpiGroupsOfSelectedClient = !_.isEmpty(data) ? data : [];
          this.sortKpiGroups();
          this.filterKpiGroupsByProject();
        },
        error: () => {
          console.error("Error on GET in getKpiGroupsOfSelectedClient()");
          this.globals.showErrorSnackbar("KPI Group request failed");
        },
      });
    },
    filterKpiGroupsByProject() {
      this.selectedKpiGroupGuid = "";
      this.projectKpiGroupList = [];

      if (this.selectedProjectGuid) {
        let listOfProjectKpiGroup = this.kpiGroupsOfSelectedClient.filter(
          (kpiGroup) => {
            if (!kpiGroup.Projects) return false;
            return (
              kpiGroup.Projects[0].ProjectGuid === this.selectedProjectGuid
            );
          }
        );
        if (listOfProjectKpiGroup.length > 0)
          this.projectKpiGroupList = listOfProjectKpiGroup;
      }
    },
    sortKpiGroups() {
      this.kpiGroupsOfSelectedClient.sort((a, b) => {
        if (a.KPIGroupCode.toLowerCase() < b.KPIGroupCode.toLowerCase())
          return -1;
        if (a.KPIGroupCode.toLowerCase() > b.KPIGroupCode.toLowerCase())
          return 1;
        return 0;
      });
    },
    getKpisOfSelectedKpiGroup() {
      if (!this.selectedKpiGroupGuid) {
        this.kpisOfSelectedKpiGroup = [];
        return;
      }
      let queryString = `api/KPIGroups/${this.selectedKpiGroupGuid}`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (!data || !data[0] || _.isEmpty(data[0]) || !data[0].KPIs) {
            this.selectedKpiGroupInformation = {};
            this.kpisOfSelectedKpiGroup = [];
            return;
          }
          this.selectedKpiGroupInformation = data[0];
          this.kpisOfSelectedKpiGroup = data[0].KPIs;
          this.sortKpisByGroupPosition();
        },
        error: () => {
          console.error("Error on GET in getKpisOfSelectedKpiGroup()");
          this.globals.showErrorSnackbar("KPIs request failed");
        },
      });
    },
    getKpiData() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIs_Read")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIs_Read");
        this.selectedKpiGuid = "";
        return;
      }
      this.refreshEnabled = false;
      let queryString = `api/KPIs/${this.selectedKpiGuid}`;

      this.showAlert = false;
      this.selectedKpiDirty = false;
      this.resetValidationErrors("editKpiDialog");

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (!data || !data[0] || _.isEmpty(data[0])) {
            this.selectedKpiInformation = {};
            return;
          }
          this.selectedKpiInformation = data[0];
        },
        error: () => {
          console.error("KPI data request failed in getKpiData()");
          this.globals.showErrorSnackbar("KPI data request failed");
        },
        complete: () => {
          this.refreshEnabled = true;
        },
      });
    },
    validateBeforeSubmit(dialog) {
      var result = true;
      var elements = $("#" + dialog).find(":input");
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          result = this.validateInput(elements[i].id) && result;
      }
      if (dialog === "editKpiDialog") {
        this.showAlert = !result;
        if (!result) return;
        this.saveEditKpiDialogData();
      }
    },
    validateInput(id) {
      var result = $("#" + id)[0].checkValidity();
      if (result) {
        $("#" + id)
          .parent()
          .parent()
          .removeClass("has-error");
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1);
        }
      } else {
        $("#" + id)
          .parent()
          .parent()
          .addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id);
      }
      return result;
    },
    inputHasError(id) {
      return this.invalidInputIds.indexOf(id) > -1 ? true : false;
    },
    resetValidationErrors(dialog) {
      var elements = $("#" + dialog).find(":input");
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          $("#" + elements[i].id)
            .parent()
            .parent()
            .removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    openDeleteKpiConfirmationDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIs_Delete")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIs_Delete");
        return;
      }
      this.globals.$emit(
        "openGlobalConfirmationDialog",
        this.getDeleteDialogData()
      );
    },
    getDeleteDialogData() {
      return {
        initiator: "KPIDeleteModal",
        confirmationTitle: this.lang.KM2019,
        colorRed: true,
        yesButtonText: this.lang.KM2020,
        noButtonText: this.lang.KM2021,
        htmlText: `<p><b>${this.lang.KM2022}</b></p>
        <div class="form-group">
          <label class="col-md-4 text-black">${this.lang.KM2023}</label>
          <label class="col-md-8 text-black">${this.selectedKpiInformation.KPIId}</label>
        </div>
        <div class="form-group">
          <label class="col-md-4 text-black">${this.lang.KM2024}</label>
          <label class="col-md-8 text-black">${this.selectedKpiInformation.KPICode}</label>
        </div>
        <div class="form-group">
          <label class="col-md-4 text-black">${this.lang.KM2025}</label>
          <label class="col-md-8 text-black">${this.selectedKpiInformation.KPIShortText}</label>
        </div>`,
      };
    },
    deleteSelectedKpi() {
      let queryString = `api/KPIs/${this.selectedKpiGuid}`;
      $.ajax({
        method: "DELETE",
        url: queryString,
        success: (data) => {
          this.globals.showSuccessSnackbar("KPI deletion successful");
          this.createNewKpi();
          this.getKpisOfSelectedKpiGroup();
          this.$forceUpdate();
        },
        error: () => {
          console.error("KPI deletion failed in deleteSelectedKpi()");
          this.globals.showErrorSnackbar("KPI deletion failed");
        },
      });
    },
    // Reorders kpis of a kpi group after the position of a kpi changed
    reorderKpisInKpiGroup() {
      let numberOfKpis = this.kpisOfSelectedKpiGroup.length,
        allPositions = _.range(1, numberOfKpis + 1),
        missingPos = 0,
        newPos = 0,
        kpiGuid = "";

      // Find missing position number and the position and code of the changed kpi
      allPositions.forEach((position, index) => {
        if (position !== this.kpisOfSelectedKpiGroup[index].KPIGroupPosition) {
          missingPos = position;
          newPos = this.kpisOfSelectedKpiGroup[index].KPIGroupPosition;
          kpiGuid = this.kpisOfSelectedKpiGroup[index].KPIGuid;
        }
      });

      if (missingPos === 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.kpisOfSelectedKpiGroup[i].KPIGuid !== kpiGuid) {
          // Do NOT move the changed kpi
          if (
            this.kpisOfSelectedKpiGroup[i].KPIGroupPosition < missingPos &&
            this.kpisOfSelectedKpiGroup[i].KPIGroupPosition >= newPos
          )
            this.kpisOfSelectedKpiGroup[i].KPIGroupPosition++;
          if (
            this.kpisOfSelectedKpiGroup[i].KPIGroupPosition > missingPos &&
            this.kpisOfSelectedKpiGroup[i].KPIGroupPosition <= newPos
          )
            this.kpisOfSelectedKpiGroup[i].KPIGroupPosition--;
        }
      }
      this.sortKpisByGroupPosition();
    },
    sortKpisByGroupPosition() {
      if (!this.kpisOfSelectedKpiGroup == "undefined") return;
      this.kpisOfSelectedKpiGroup.sort(
        (a, b) => a.KPIGroupPosition - b.KPIGroupPosition
      );
    },
    saveKpisNewOrder() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_Update")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Update");
        return;
      }

      let queryString = `api/KPIGroups/${this.selectedKpiGroupGuid}`;
      this.selectedKpiGroupInformation.KPIs = this.kpisOfSelectedKpiGroup;
      $.ajax({
        method: "PUT",
        url: queryString,
        data: JSON.stringify(this.selectedKpiGroupInformation),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.globals.showSuccessSnackbar("KPI Group update successful");
          this.changeKpiOrderDirty = false;
          this.getKpisOfSelectedKpiGroup();
        },
        error: () => {
          console.error("Error on POST in saveEditKPIGroupDialogData()");
          this.globals.showErrorSnackbar("KPI Group update failed");
        },
      });
    },
    getKPIGroup(kpiGroupGuid) {
      let result = this.kpiGroupsOfSelectedClient.find(
        (element) => element.KPIGroupGuid === kpiGroupGuid
      );
      return {
        KPIGroupGuid: result.KPIGroupGuid,
        KPIGroupCode: result.KPIGroupCode,
      };
    },
    saveEditKpiDialogData() {
      if (
        !this.globals.isAccessAllowed("LoopOp_KPIs_Create") &&
        !this.selectedKpiGuid
      ) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIs_Create");
        return;
      } else if (
        !this.globals.isAccessAllowed("LoopOp_KPIs_Update") &&
        this.selectedKpiGuid
      ) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIs_Update");
        return;
      }

      let queryString = !this.selectedKpiGuid
        ? `api/KPIs` // new kpi group
        : `api/KPIs/${this.selectedKpiGuid}`; // update exisiting kpi group
      let kpiGroup = this.getKPIGroup(this.selectedKpiGroupGuid);
      if (this.selectedKpiInformation.KPIGroups)
        this.selectedKpiInformation.KPIGroups = [];
      this.selectedKpiInformation.KPIGroups.push(kpiGroup);

      if (!this.selectedKpiInformation.KPIEvaluationRuleGuid)
        delete this.selectedKpiInformation.KPIEvaluationRuleGuid;

      if (this.selectedKpiInformation.KPIWeight === "")
        delete this.selectedKpiInformation.KPIWeight;

      if (!this.selectedKpiGuid) {
        $.ajax({
          method: "POST",
          url: queryString,
          data: JSON.stringify(this.selectedKpiInformation),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            this.globals.showSuccessSnackbar("KPI creation successful");
            this.selectedKpiGuid = data[0].KPIGuid;
            this.selectedKpiInformation = _.cloneDeep(data[0]);
            this.selectedKpiDirty = false;
            this.getKpisOfSelectedKpiGroup();
          },
          error: () => {
            console.error("Error on POST in saveEditKpiDialogData()");
            this.globals.showErrorSnackbar("KPI creation failed");
          },
        });
      } else {
        $.ajax({
          method: "PUT",
          url: queryString,
          data: JSON.stringify(this.selectedKpiInformation),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            this.globals.showSuccessSnackbar("KPI update successful");
            this.selectedKpiDirty = false;
            this.getKpisOfSelectedKpiGroup();
          },
          error: () => {
            console.error("Error on POST in saveEditKpiDialogData()");
            this.globals.showErrorSnackbar("KPI update failed");
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.modal-lg {
  width: calc(100vw - 300px);
}

.table-container {
  height: calc(100vh - 300px);
  overflow-y: auto;
}

.table-positions {
  height: calc(100vh - 355px);
}

.modal-content {
  background-color: #eee;
}

#editKpiDialog .panel-body {
  padding: 0 !important;
}

.modal-footer .btn-default {
  background: rgb(190, 190, 190);
}

.btn-top-bar.btn.btn-raised {
  margin-bottom: 10px;
}
.btn-top-bar.btn.btn-raised.btn-warning {
  background-color: #ff5722;
}

.btn.btn-raised.btn-warning:hover {
  background-color: #ec5122ab;
}

.nav-kpi-edit {
  background-color: var(--color-primary);
  padding: 0px;
}

.nav-kpi-edit > li {
  text-align: center;
  float: none;
  display: inline-block;
}

.nav-kpi-edit > li.active {
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-kpi-edit > li.active > a {
  font-weight: bold;
}

#editKpiDialog .form-horizontal .form-group {
  margin: 0;
}

#editKpiTab .form-group > label > i.material-icons {
  position: absolute;
  top: 5px;
  right: -5px;
}
</style>



// WEBPACK FOOTER //
// KPIManagementEditModal.vue?cf8ddae0